// Make this flag available to the client-side (JavaScript) SDK

import { TogglesReduxState } from './feature-togglings'

// If you want these common features to appear client side ensure that in launch darkly the following checkbox is enabled
export type Features =
    | 'breach-regional-override'
    | 'breach-ab-testing'
    | 'launch-darkly-a-b-testing'
    | 'a-b-testing-features'
    | 'breach-ab-test-1'
    | 'breach-ab-test-2'
    | 'brightcove-player'
    | 'ix-header-tag-wrapper'
    | 'email-author'
    | 'google-tag-manager'
    | 'gpt-ads'
    | 'nielsen-events'
    | 'refresh-on-inactive'
    | 'can-autoplay-video'
    | 'can-autoplay-muted-video'
    | 'can-autoplay-next'
    | 'big-mobile-amp'
    | 'related-content'
    | 'snowplow'
    | 'prebid-video'
    | 'debug-ads'
    | 'newsletter-subscription-banner'
    | 'sticky-mrec'
    | 'standalone-amp-swm-player'
    | 'moat-adx-ad-tracking'
    | 'nielsen-video-events'
    | 'inline-card-video'
    | 'search'
    | 'canary'
    | 'world-collection'
    // | 'use-oovvuu-recommendation'
    | 'cricketball'
    | 'digital-subscriptions'
    | 'bonzai-truskin'
    | 'outstream'
    | 'ad-tech-dfp-testing'
    | 'nielsen-video-events-inline-videos'
    | 'grapeshot'
    | 'mmo-bypass'
    | 'paywall-bypass-header'
    | 'ripple'
    | 'regionals'
    | 'immersive-story-article-template'
    | 'telethon-countdown'
    | 'running-parallax'
    | 'logo-takeover'
    | 'afl-draft'
    | 'simple-digital-subscription-form'
    | 'moat-yield-intelligence'
    | 'exclude-regional-topics-from-lists'
    | 'video-playlist'
    | 'cookie-consent'
    | 'community-news'
    | 'puzzles-target'
    | 'the-west-live'
    | 'playlists-on-inline-videos'
    | 'force-west-live-activation'
    | 'video-series'
    | 'sport-breach-screen-variant'
    | 'taboola'
    | 'taboola-regionals'
    | 'companion-ads'
    | 'story-classification'
    | 'the-west-rewards'
    | 'registration-wall'
    | 'comments'
    | 'hero-image-as-video-poster'
    | 'native-chartbeat'
    | 'black-friday'
    | 'black-friday-promo-strap-style'
    | 'top-50-schools'
    | '50-off-afl-breach-screen'
    | 'eofy'
    | 'use-internal-content-api'
    | 'breach-190-year'
    | 'breach-puzzles-swg-30'
    | 'adobe-audience-manager'
    | 'adobe-fonts'
    | 'newsletter-subscriptions'
    | 'nielsen-subbrand'
    | 'app-upgrade-screen'
    | 'the-west-logo'
    | 'route-west-tonight'
    | '50-off-breach-discount'
    | 'south-west-curations'
    | 'sophi'
    | 'user-accounts'
    | '7news-taboola-midarticle'
    | 'cng-to-perth-now-rebrand'
    | 'route-up-late'
    | 'jab-tracker'
    | 'puzzles'
    | 'digital-edition-redirects'
    | 'the-west-grand-final'
    | 'the-west-grand-final-collection'
    | 'perthnow-streamer-screamer-play-of-the-day'
    | 'live-ramp-ats'
    | 'live-ramp-ats-v2'
    | '7ent-article-related'
    | '7news-contextual-link'
    | 'the-west-cnbc'
    | 'subscribe-with-google'
    | 'cricket-widgets'
    | 'queen-elizabeth-tributes-route'
    | 'swg-breach-default'
    | 'swg-breach-albany-advertiser'
    | 'swg-breach-great-southern-herald'
    | 'swg-breach-augusta-margaret-river-times'
    | 'swg-breach-busselton-dunsborough-times'
    | 'swg-breach-broome-advertiser'
    | 'swg-breach-the-kimberley-echo'
    | 'swg-breach-geraldton-guardian'
    | 'swg-breach-midwest-times'
    | 'swg-breach-bunbury-herald'
    | 'swg-breach-harvey-waroona-reporter'
    | 'swg-breach-manjimup-bridgetown-times'
    | 'swg-breach-south-western-times'
    | 'swg-breach-kalgoorlie-miner'
    | 'swg-breach-narrogin-observer'
    | 'swg-breach-north-west-telegraph'
    | 'swg-breach-pilbara-news'
    | 'swg-breach-sound-telegraph'
    | 'swg-breach-countryman'
    | 'climate-change-home'
    | 'the-west-bar-regional'
    | 'taboola-bb-vip-show-page'
    | 'swg-entitlements-check'
    | 'perth-now-pride-logo'
    | 'custom-sample-middleware'
    | 'feature-toggle-override'
    | 'subscriber-dropdown'
    | 'subscriber-feature-tooltip'
    | '7-news-lifestyle-article-related-card'
    | '7-news-lifestyle-four-column-taboola-feed'
    | '7-news-lifestyle-article-full-page-display'
    | '7-news-lifestyle-contextual-link'
    | 'hide-mobile-breaking-news-banner'
    | '7-news-sas-australia-article-related-card'
    | 'amp-read-more'
    | 'swg-account-linking'
    | '7-news-dwts-contextual-link'
    | '7-news-politics-full-page-article-display'
    | 'force-ads-hidden-until-loaded-false'
    | '7-news-sport-article-full-page-display'
    | '7-news-tech-full-article-page-display'
    | '7-news-article-full-page-display'
    | '7-news-world-full-article-page-display'
    | 'pollie-rater-drivers'
    | '7-news-taboola-read-more-amp-articles'
    | 'live-coverage-driver'
    | '7-news-spotlight-full-article-display'
    | '7-news-taboola-newsroom'
    | 'ipsos-tracking'
    | 'ipsos-tracking-amp'
    | 'geoblock-nsw-foul-play'
    | 'foul-play-editorial-feature'
    | '7-news-taboola-web-push'
    | 'subs-campaign-eofy-weekend-digital'
    | 'default-price-increase'
    | 'subs-campaign-business-pack-2022'
    | 'subs-campaign-sport-pack-2022'
    | 'subs-campaign-bali-bombing-2022'
    | 'PerthNow-rightsiderail-desktop-digital-edition-driver'
    | 'PerthNow-in-article-digital-edition-driver'
    | '7-news-google-web-stories-home-page'
    | '7-news-navigation-video-hub'
    | 'the-west-increased-article-font'
    | 'commonwealth-games-4card-curation'
    | 'commonwealth-games-play-of-the-day'
    | 'exclude-video-series-from-playlists'
    | 'commonwealth-games-sports-page-curation'
    | 'timespool-navigation'
    | 'do-not-refresh-while-inactive'
    | '7-news-individual-video-watch-page'
    | '7-news-redirect-logic'
    | 'web-stories'
    | 'the-west-grand-final-collection-home-4'
    | 'the-west-grand-final-freo-collection-theme'
    | 'the-west-grand-final-collection-home-8'
    | 'flagmantle-route'
    | '7-news-video-hub-topic-page'
    | 'queens-tribute-in-article-banners'
    | 'perthnow-play-of-the-day'
    | 'best-australian-yarn-curation-segment'
    | 'best-australian-yarn-route'
    | '7-news-video-hub-playlist-fix'
    | 'bali-bombings-feature-route'
    | 'subscriber-exclusive-subscriber-service-curation'
    | '7-news-cricket-fixture-scorecard'
    | 'exclusive_content'
    | 'gtm4'
    | 'BAY-top-14'
    | 'BAY-top-50'
    | 'extra-inline-article-ads'
    | 'tp-subscription-subscribe-button-design'
    | 'tp-subscription-new-breach-package-design'
    | 'tp-subscription-new-breach-package-background'
    | 'tp-subscription-breach-show-part-article'
    | 'tp-subscription-abandoned-cart'
    | 'tp-subscription-hero-variation'
    | 'teachers-offering'
    | 'university-offering'
    | 'ePaper'
    | 'genwest'
    | 'genwest-taboola'
    | 'genwest-ad-slots'
    | 'trading-up'
    | 'trading-up-stake-images'
    | '7-news-linkby-pubfeed'
    | '7news-mobile-video-autoplay'
    | '7-news-sponsored-disclaimer'
    | '7-news-afl-fixture-scoreboard'
    | 'round-style-perth-now'
    | 'smartocto'
    | 'perth-now-match-centre'
    | '7-news-match-centre-odds-toggle'
    | 'perth-now-afl-fixture-scoreboard'
    | 'trading-up-homepage'
    | 'video-hub'
    | 'the-west-match-centre'
    | 'the-west-afl-fixture-scoreboard'
    | 'afl-match-centre-driver'
    | 'datadog-client'
    | 'perthnow-taboola-web-push'
    | 'the-west-wafl-landing'
    | 'best-australian-yarn-gen-west'
    | 'mad-monday-route'
    | 'tw-1000-promo'
    | 'breachwall-banner'
    | '7-news-main-navigation-update'
    | '190-years-of-the-west'
    | '7-news-adfixus-script-tag'
    | '190-years-of-the-west-masthead'
    | '7news-tv-guide-navigation'
    | 'pn-skimlinks-script'
    | '7-news-skimlinks-script'
    | 'go-matildas-masthead'
    | 'go-matildas-messages-route'
    | 'go-matildas-homepage-collection'
    | 'go-matildas-article-banner'
    | 'shop-now-topic'
    | 'regional-readers-survey'
    | 'court-in-the-act'
    | 'best-australian-short-film'
    | '7-news-parsely-script'
    | '7-news-trendii-script'
    | 'court-in-the-act-article-banner'
    | 'vanishing-cousins-feature-route'
    | 'vanishing-cousins-sub-exclusive-banner'
    | 'vanishing-cousins-breach-screen'
    | '7-news-2-article-page'
    | '7-news-tv-guide-widgets'
    | '7news-real-estate-view-widget'
    | 'auth0'
    | 'third-party-noindex-nofollow-meta-tags'
    | '7-news-2-home-page-pill-menu'
    | '7-news-2-pill-menu'
    | '7-news-just-in-carousel'
    | '7-news-footer-newsletter'
    | '7-news-2-home-page'
    | 'inline-create-account-cta'
    | 'BASF-feature-page'
    | 'BASF-top-30'
    | '7-news-video-playlist-removal'
    | '7-news-newsletter-route'
    | 'web-app-download'
    | '7-news-2-author-profile'
    | 'tn-enable-pagination'
    | 'tn-inline-video-enabled'
    | 'tn-promo-banner'
    | 'tn-homepage-odd-topic-ads'
    | 'tn-article-body-ads'
    | '7-news-2-top-leaderboard-ad'
    | 'tn-raise-homepage-adslot'
    | '7-news-app-smart-banner'
    | '7-news-app-smart-banner-android'
    | 'magnite-header-tag-wrapper'
    | '7-news-2-video-hub'
    | 'car-expert-canonical'
    | '7-news-app-contextual-link'
    | '7-news-watch-7-plus-nav'
    | '7-news-app-site-promotion'
    | '7-news-app-page'
    | 'teads-article-ads'
    | 'perthnow-new-auth-tenant'
    | 'live-event-pagination'
    | 'retire-ready-feature-page'
    | '7-news-search-bar'
    | 'paris-olympics-homepage-collection'
    | 'paris-olympics-collection-tally'
    | 'paris-olympics-2024'
    | 'paris-olympics-widgets'
    | 'sf-preference-centre'
    | 'search-pagination'
    | 'app-smart-banner-ios'
    | 'app-smart-banner-android'

export interface ABTestingFeature {
    variants: Array<ABTestingFeatureVariant>
}

export interface ABTestingFeatureVariant {
    on: { percentage: number; value: unknown }
    defaultValue: unknown
}
export type ABTestingFeatures = Omit<
    { [K in Features]?: ABTestingFeature },
    'a-b-testing-features'
>

export const testFeatureState: TogglesReduxState = {
    'breach-regional-override': false,
    'breach-ab-testing': true,
    'launch-darkly-a-b-testing': false,
    'breach-ab-test-1': 'a',
    'breach-ab-test-2': 1,
    'a-b-testing-features': {
        'breach-ab-test-1': {
            variants: [
                {
                    on: { percentage: 25, value: 'a' },
                    defaultValue: 'a',
                },
                {
                    on: { percentage: 50, value: 'b' },
                    defaultValue: 'a',
                },
                {
                    on: { percentage: 75, value: 'c' },
                    defaultValue: 'a',
                },
                {
                    on: { percentage: 100, value: 'd' },
                    defaultValue: 'a',
                },
            ],
        },
        'breach-ab-test-2': {
            variants: [
                {
                    on: { percentage: 25, value: 1 },
                    defaultValue: 1,
                },
                {
                    on: { percentage: 50, value: 2 },
                    defaultValue: 1,
                },
                {
                    on: { percentage: 75, value: 3 },
                    defaultValue: 1,
                },
                {
                    on: { percentage: 100, value: 4 },
                    defaultValue: 1,
                },
            ],
        },
    },
    'perthnow-taboola-web-push': true,
    ePaper: true,
    'video-hub': true,
    'BAY-top-14': true,
    'BAY-top-50': true,
    'world-collection': true,
    'brightcove-player': true,
    'ix-header-tag-wrapper': true,
    'email-author': true,
    'google-tag-manager': true,
    'gpt-ads': true,
    'nielsen-events': true,
    'refresh-on-inactive': false,
    'can-autoplay-video': true,
    'can-autoplay-next': false,
    'can-autoplay-muted-video': false,
    'big-mobile-amp': false,
    'related-content': false,
    snowplow: true,
    'prebid-video': true,
    search: false,
    'debug-ads': false,
    'newsletter-subscription-banner': false,
    'sticky-mrec': false,
    'standalone-amp-swm-player': false,
    'moat-adx-ad-tracking': true,
    'nielsen-video-events': true,
    'inline-card-video': true,
    canary: false,
    // 'use-oovvuu-recommendation': false,
    cricketball: false,
    'digital-subscriptions': false,
    'bonzai-truskin': false,
    outstream: false,
    'ad-tech-dfp-testing': true,
    'nielsen-video-events-inline-videos': false,
    grapeshot: false,
    'mmo-bypass': false,
    'paywall-bypass-header': true,
    ripple: false,
    regionals: true,
    'immersive-story-article-template': false,
    'telethon-countdown': false,
    'running-parallax': false,
    'logo-takeover': false,
    'afl-draft': false,
    'simple-digital-subscription-form': false,
    'moat-yield-intelligence': false,
    'exclude-regional-topics-from-lists': false,
    'video-playlist': false,
    'cookie-consent': false,
    'community-news': true,
    'cng-to-perth-now-rebrand': true,
    'the-west-live': false,
    'playlists-on-inline-videos': false,
    'force-west-live-activation': false,
    'video-series': true,
    'sport-breach-screen-variant': true,
    taboola: true,
    'taboola-regionals': true,
    'companion-ads': false,
    'story-classification': true,
    'the-west-rewards': true,
    'registration-wall': true,
    comments: false,
    'hero-image-as-video-poster': true,
    'native-chartbeat': true,
    'black-friday': false,
    'black-friday-promo-strap-style': false,
    'top-50-schools': true,
    'use-internal-content-api': true,
    '50-off-afl-breach-screen': true,
    'breach-190-year': true,
    'breach-puzzles-swg-30': true,
    'adobe-audience-manager': false,
    'adobe-fonts': true,
    'newsletter-subscriptions': true,
    'nielsen-subbrand': true,
    'app-upgrade-screen': true,
    'the-west-logo': true,
    'route-west-tonight': true,
    '50-off-breach-discount': false,
    'south-west-curations': false,
    sophi: false,
    'user-accounts': false,
    '7news-taboola-midarticle': true,
    'route-up-late': true,
    'jab-tracker': true,
    'puzzles-target': false,
    puzzles: true,
    'digital-edition-redirects': true,
    'the-west-grand-final': true,
    'the-west-grand-final-collection': true,
    'perthnow-streamer-screamer-play-of-the-day': true,
    'live-ramp-ats': true,
    'live-ramp-ats-v2': true,
    '7ent-article-related': true,
    '7news-contextual-link': true,
    'the-west-cnbc': true,
    'subscribe-with-google': false,
    'cricket-widgets': true,
    'swg-breach-default': false,
    'swg-breach-albany-advertiser': false,
    'swg-breach-great-southern-herald': false,
    'swg-breach-augusta-margaret-river-times': false,
    'swg-breach-busselton-dunsborough-times': false,
    'swg-breach-broome-advertiser': false,
    'swg-breach-the-kimberley-echo': false,
    'swg-breach-geraldton-guardian': false,
    'swg-breach-midwest-times': false,
    'swg-breach-bunbury-herald': false,
    'swg-breach-harvey-waroona-reporter': false,
    'swg-breach-manjimup-bridgetown-times': false,
    'swg-breach-south-western-times': false,
    'swg-breach-kalgoorlie-miner': false,
    'swg-breach-narrogin-observer': false,
    'swg-breach-north-west-telegraph': false,
    'swg-breach-pilbara-news': false,
    'swg-breach-sound-telegraph': false,
    'swg-breach-countryman': false,
    'climate-change-home': false,
    'the-west-bar-regional': true,
    'taboola-bb-vip-show-page': true,
    'swg-entitlements-check': false,
    'perth-now-pride-logo': false,
    'custom-sample-middleware': false,
    'feature-toggle-override': true,
    'subscriber-dropdown': true,
    'subscriber-feature-tooltip': true,
    '7-news-lifestyle-article-related-card': true,
    '7-news-lifestyle-four-column-taboola-feed': true,
    '7-news-lifestyle-article-full-page-display': true,
    '7-news-lifestyle-contextual-link': true,
    'hide-mobile-breaking-news-banner': true,
    '7-news-sas-australia-article-related-card': true,
    'amp-read-more': true,
    'swg-account-linking': false,
    '7-news-dwts-contextual-link': true,
    '7-news-politics-full-page-article-display': true,
    'force-ads-hidden-until-loaded-false': true,
    '7-news-sport-article-full-page-display': true,

    '7-news-tech-full-article-page-display': true,
    '7-news-article-full-page-display': true,
    '7-news-world-full-article-page-display': true,

    'pollie-rater-drivers': true,
    '7-news-taboola-read-more-amp-articles': true,
    'live-coverage-driver': true,
    '7-news-spotlight-full-article-display': true,
    '7-news-taboola-newsroom': true,
    'ipsos-tracking': true,
    'ipsos-tracking-amp': true,
    'geoblock-nsw-foul-play': true,
    'foul-play-editorial-feature': true,
    '7-news-taboola-web-push': true,
    'subs-campaign-eofy-weekend-digital': false,
    'subs-campaign-sport-pack-2022': false,
    'subs-campaign-business-pack-2022': false,
    'subs-campaign-bali-bombing-2022': false,
    'default-price-increase': false,
    'PerthNow-rightsiderail-desktop-digital-edition-driver': false,
    'PerthNow-in-article-digital-edition-driver': false,
    '7-news-google-web-stories-home-page': true,
    '7-news-navigation-video-hub': true,
    'the-west-increased-article-font': false,
    'commonwealth-games-4card-curation': false,
    'commonwealth-games-play-of-the-day': true,
    'exclude-video-series-from-playlists': false,
    'commonwealth-games-sports-page-curation': false,
    'timespool-navigation': true,
    'do-not-refresh-while-inactive': false,
    '7-news-individual-video-watch-page': true,
    '7-news-redirect-logic': true,
    'web-stories': true,
    'the-west-grand-final-collection-home-4': false,
    'the-west-grand-final-freo-collection-theme': false,
    'the-west-grand-final-collection-home-8': false,
    'flagmantle-route': true,
    '7-news-video-hub-topic-page': true,
    'queens-tribute-in-article-banners': true,
    'perthnow-play-of-the-day': true,
    'best-australian-yarn-curation-segment': true,
    'best-australian-yarn-route': true,
    '7-news-video-hub-playlist-fix': false,
    'bali-bombings-feature-route': true,
    'subscriber-exclusive-subscriber-service-curation': true,
    '7-news-cricket-fixture-scorecard': true,
    exclusive_content: true,
    gtm4: false,
    'extra-inline-article-ads': true,
    'tp-subscription-subscribe-button-design': false,
    'tp-subscription-new-breach-package-design': false,
    'tp-subscription-new-breach-package-background': false,
    'tp-subscription-breach-show-part-article': false,
    'tp-subscription-abandoned-cart': false,
    'tp-subscription-hero-variation': 'a',
    'teachers-offering': true,
    'university-offering': true,
    genwest: true,
    'genwest-taboola': false,
    'genwest-ad-slots': false,
    'trading-up': true,
    'trading-up-stake-images': true,
    '7-news-linkby-pubfeed': true,
    'afl-match-centre-driver': false,
    '7news-mobile-video-autoplay': true,
    '7-news-sponsored-disclaimer': true,
    '7-news-afl-fixture-scoreboard': true,
    'round-style-perth-now': true,
    smartocto: false,
    'perth-now-match-centre': true,
    '7-news-match-centre-odds-toggle': true,
    'trading-up-homepage': true,
    'the-west-match-centre': true,
    'the-west-afl-fixture-scoreboard': true,
    'datadog-client': false,
    'best-australian-yarn-gen-west': true,
    'mad-monday-route': true,
    'the-west-wafl-landing': true,
    'tw-1000-promo': false,
    'breachwall-banner': true,
    '7-news-main-navigation-update': true,
    '190-years-of-the-west': true,
    '7-news-adfixus-script-tag': true,
    '190-years-of-the-west-masthead': false,
    '7news-tv-guide-navigation': true,
    '7-news-skimlinks-script': true,
    'pn-skimlinks-script': true,
    'go-matildas-masthead': false,
    'go-matildas-homepage-collection': true,
    'go-matildas-article-banner': false,
    'shop-now-topic': false,
    'regional-readers-survey': false,
    'court-in-the-act': true,
    'best-australian-short-film': true,
    '7-news-parsely-script': true,
    '7-news-trendii-script': true,
    'court-in-the-act-article-banner': false,
    'vanishing-cousins-feature-route': false,
    'vanishing-cousins-sub-exclusive-banner': true,
    'vanishing-cousins-breach-screen': false,
    '7-news-2-article-page': true,
    '7-news-tv-guide-widgets': true,
    '7news-real-estate-view-widget': true,
    auth0: true,
    'third-party-noindex-nofollow-meta-tags': true,
    '7-news-2-home-page-pill-menu': true,
    '7-news-2-pill-menu': true,
    '7-news-just-in-carousel': false,
    '7-news-footer-newsletter': true,
    '7-news-2-home-page': true,
    'inline-create-account-cta': true,
    'BASF-feature-page': true,
    'BASF-top-30': true,
    '7-news-video-playlist-removal': true,
    '7-news-newsletter-route': true,
    'web-app-download': true,
    '7-news-2-author-profile': true,
    'tn-enable-pagination': false,
    'tn-inline-video-enabled': true,
    'tn-promo-banner': false,
    'tn-homepage-odd-topic-ads': false,
    'tn-article-body-ads': false,
    '7-news-2-top-leaderboard-ad': true,
    'tn-raise-homepage-adslot': true,
    '7-news-app-smart-banner': true,
    '7-news-app-smart-banner-android': true,
    'magnite-header-tag-wrapper': true,
    '7-news-2-video-hub': true,
    'car-expert-canonical': true,
    '7-news-app-contextual-link': true,
    '7-news-watch-7-plus-nav': true,
    '7-news-app-site-promotion': true,
    '7-news-app-page': true,
    'teads-article-ads': false,
    'retire-ready-feature-page': false,
    '7-news-search-bar': true,
    'paris-olympics-homepage-collection': false,
    'paris-olympics-collection-tally': false,
    'paris-olympics-2024': false,
    'paris-olympics-widgets': false,
    'sf-preference-centre': false,
    'search-pagination': true,
    'app-smart-banner-ios': true,
    'app-smart-banner-android': true
}
